// extracted by mini-css-extract-plugin
module.exports = {"layout":"M_3","content":"M_K","title":"M_l","subtitle":"M_6","subtitleBold":"M_dD","apps":"M_dF","cardChat":"M_dG","chat":"M_dH","search":"M_dJ","share":"M_dK"};